<template>
  <div class="container">
    <!-- Header 占位符 -->
    <exam-header :canClickLogo="true"></exam-header>
    <!-- 主要内容区域 -->
    <div class="page-content">
      <div class="page-content-head">
        <div class="page-title-warp">
          <div class="back" @click="goBack"><i class="el-icon-arrow-left"></i>返回</div>
          <div class="title"><i></i>用户管理</div>
        </div>

        <!-- 筛选表单 -->
        <div class="filter-section">
          <el-form :model="filterForm" :inline="true" class="filter-form">
            <el-form-item label="业务类型:">
              <el-select v-model="filterForm.level" placeholder="请选择" class="form-select-width">
                <el-option :label="item.label" :value="item.id" v-for="(item,index) in EXAM_LEVEL_TYPE" :key="index" />
              </el-select>
            </el-form-item>
            <el-form-item label="用户名称:">
              <el-input
                  v-model="filterForm.username"
                  placeholder="请选择"
                  clearable>
              </el-input>
            </el-form-item>
            <el-form-item label="用户手机号:">
              <el-input
                  v-model="filterForm.mobile"
                  placeholder="请输入"
                  clearable>
              </el-input>
            </el-form-item>
            <el-form-item label="用户学校:">
              <el-select v-model="filterForm.schoolId" placeholder="请选择" class="form-select-width">
                <el-option label="全部" value=""></el-option>
                <el-option :label="item.schoolName" :value="item.id" v-for="(item,index) in userSchoolList" :key="index"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="角色:">
              <el-select v-model="filterForm.role" placeholder="请选择">
                <el-option label="全部" value=""></el-option>
                <el-option :label="ROLE_MAP[item]" :value="item" v-for="(item) in Object.keys(ROLE_MAP)" :key="item"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="form-btns">
            <div class="create-btns">
              <el-button type="primary" @click="handleCreateAccount" class="create-btn"><i class="el-icon-plus"></i>创建账号</el-button>
              <el-button type="primary" @click="handleBatchCreateAccount" class="createAll-btn"><i class="el-icon-plus"></i>批量创建账号</el-button>
            </div>
            <div class="search-btns">
              <el-button type="primary" @click="handleSearch" class="search-btn">查询</el-button>
              <el-button @click="handleReset" class="reset-btn">重置</el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="page-content-body">
        <!-- 用户列表表格 -->
        <div class="table-section">
          <el-table
            :data="userList"
            style="width: 100%"
            v-loading="loading">
            <el-table-column label="序号" width="80" align="center">
              <template slot-scope="scope">
                {{ scope.row.identityId }}
              </template>
            </el-table-column>
            <el-table-column prop="username" label="用户名称" width="80"></el-table-column>
            <el-table-column prop="mobile" label="用户手机号" width="120"></el-table-column>
            <el-table-column prop="role" label="角色／用户学校" min-width="300" align="left">
              <template slot-scope="scope">
                <div class="roles-container">
                  <div
                    class="role-item"
                    v-for="(group, idx) in getGroupedRoleList(scope.row.schoolRelations)"
                    :key="group.role + '-' + idx"
                  >
                    <roles-tag :role="group.role" />
                    <div class="role-schools">
                      <span v-for="(name, i) in group.schools" :key="name + '-' + i">
                      {{ name }}
                      <span v-if="i !== group.schools.length - 1" style="margin: 0 5px">|</span>
                    </span>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
<!--            <el-table-column prop="userSchool"-->
<!--                             label="用户学校" min-width="200">-->
<!--              <template slot-scope="scope">-->
<!--                <div class="roles-school-list">-->
<!--                  <div-->
<!--                    class="role-schools-row"-->
<!--                    v-for="(group, idx) in getGroupedRoleList(scope.row.schoolRelations)"-->
<!--                    :key="group.role + '-' + idx"-->
<!--                  >-->
<!--                    <span v-for="(name, i) in group.schools" :key="name + '-' + i">-->
<!--                      {{ name }}-->
<!--                      <span v-if="i !== group.schools.length - 1" style="margin: 0 5px">|</span>-->
<!--                    </span>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </template>-->
<!--            </el-table-column>-->
            <el-table-column prop="level" label="业务类型" width="120">
              <template slot-scope="scope">
                <el-tag class="levelTag" type="danger"> {{EXAM_LEVEL_TYPE_ENUM[scope.row.level]}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="account" label="账号" width="120">
              <template slot-scope="scope">
                {{scope.row.userPass?.username}}
              </template>>
            </el-table-column>
            <el-table-column prop="password" label="密码" width="120">
              <template slot-scope="scope">
                {{scope.row.userPass?.password}}
              </template>>
            </el-table-column>
            <el-table-column prop="accountStatus" label="账号状态" width="100" align="center">
              <template slot-scope="scope">
                <span :class="getStatusClass(scope.row.expireTime).style">
                  {{getStatusClass(scope.row.expireTime).text }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 分页 -->
        <div class="pagination-section" v-if="userList.length">
          <div class="pagination-info">
            总共<span>{{ total }}</span>个项目
          </div>
          <div class="pagination-controls">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="pageNo"
              :page-size="pageSize"
              layout="prev, pager, next"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- 创建用户弹窗 -->
    <create-user-modal
      v-model="showCreateModal"
      :school-list="userSchoolList"
      :edit-data="editData"
      :is-edit="isEdit"
      @success="handleCreateSuccess">
    </create-user-modal>
    <page-footer></page-footer>
  </div>
</template>

<script>
import {
  Button,
  Input,
  Select,
  Option,
  Form,
  FormItem,
  Table,
  TableColumn,
  Tag,
  Pagination,
} from "element-ui";
import ExamHeader from './components/teacherExamHeader.vue';
import PageFooter from '@/components/PageFooter.vue';
import CreateUserModal from './components/createUserModal.vue';
import {EXAM_LEVEL_TYPE, ROLE_MAP, EXAM_LEVEL_TYPE_ENUM} from '@/common/constant/qz';
import {getUserSchools,getUserList} from "@/api/qzTeacher";
import {getSystemTimeSync} from "@/api/api"
import RolesTag from './components/rolesTag.vue';

export default {
  name: 'UserManagePage',
  components: {
    'el-tag':Tag,
    'el-button': Button,
    'el-input': Input,
    'el-select': Select,
    'el-option': Option,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-table': Table,
    'el-table-column': TableColumn,
    'el-pagination': Pagination,
    'exam-header': ExamHeader,
    'create-user-modal': CreateUserModal,
    'roles-tag': RolesTag,
    PageFooter,
  },
  data() {
    return {
      loading: true,
      userSchoolList: [],
      ROLE_MAP,
      EXAM_LEVEL_TYPE,
      EXAM_LEVEL_TYPE_ENUM,
      // 筛选表单数据
      filterForm: {
        username: '',
        mobile: '',
        level: 'MATHS_TALENTS_1', // 默认选择丘成桐少年班
        schoolId: '',
        role: ''
      },
      // 用户列表数据
      userList: [],
      userIdentity:{
        roles:['TEACHER','ADMIN']
      },
      // 分页数据
      pageNo: 1,
      pageSize: 20,
      total: 0,
      // 弹窗控制
      showCreateModal: false,
      // 编辑相关
      isEdit: false,
      editData: null,
    }
  },
 async created() {
    await this.getRoleUserSchools();
    await this.fetchUserList(this.filterForm);
  },
  methods: {
    goBack() {
      this.$router.push({
        name:'paperListTeacher'
      });
    },
    // 查询当前用户学校数据
    getRoleUserSchools() {
      getUserSchools(['TEACHER', 'ADMIN']).then(res => {
        if(res.code === 200 && res.body?.schools){
          this.userSchoolList = res.body?.schools;
        }
      })
    },
    // 用户列表
    fetchUserList(params){
      getUserList({
        ...params,
        pageNo: this.pageNo - 1,
        pageSize: this.pageSize
      }).then(res => {
        if(res.code === 200 && res.body?.users){
            this.userList = res.body?.users;
            this.total = res.body.totalCount;
        }else{
          this.userList = [];
          this.total = 0;
          this.$message.error(res?.message || '服务器错误')
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e?.message || '服务器错误')
      })
    },
    // 查询
    handleQuery() {
      this.loading = true;
      this.fetchUserList(this.filterForm);
      // setTimeout(() => {
      //   this.loading = false;
      // }, 1000);
    },
    handleSearch () {
      this.pageNo = 1;
      this.handleQuery()
    },
    // 重置
    handleReset() {
      this.filterForm = {
        username: '',
        mobile: '',
        level: 'MATHS_TALENTS_1',
        userSchool: '',
        role: ''
      };
      this.handleQuery();
    },

    // 创建账号
    handleCreateAccount() {
      this.isEdit = false;
      this.editData = null;
      this.showCreateModal = true;
    },

    // 批量创建账号
    handleBatchCreateAccount() {
      console.log('批量创建账号');
      // 这里应该跳转到批量创建账号页面或打开弹窗
      this.$router.push({ name: 'batchCreateAccount' });
    },

    // 编辑用户
    handleEdit(row) {
      console.log('编辑用户:', row);
      this.isEdit = true;
      console.log(this.level,'=====')
      this.editData = row;
      this.showCreateModal = true;
    },

    // 获取排序后的角色数组
    getSortedRoles(roles) {
      if (!roles || !Array.isArray(roles)) return [];
      return [...roles].sort((a, b) => {
        // ADMIN 始终排在第一位
        if (a === 'ADMIN') return -1;
        if (b === 'ADMIN') return 1;
        // 其他角色保持原有顺序
        return 0;
      });
    },

    // 根据 role 分组学校，并返回有序数组用于渲染换行
    getGroupedRoleList(relations) {
      if (!Array.isArray(relations) || relations.length === 0) return [];
      const roleToSchoolSet = new Map();
      const appearedRoleOrder = [];

      relations.forEach(rel => {
        const role = rel?.role;
        const schoolName = rel?.schoolName;
        if (!role || !schoolName) return;
        if (!roleToSchoolSet.has(role)) {
          roleToSchoolSet.set(role, new Set());
          appearedRoleOrder.push(role);
        }
        roleToSchoolSet.get(role).add(schoolName);
      });

      const orderedRoles = this.getSortedRoles(appearedRoleOrder);
      return orderedRoles.map(role => ({
        role,
        schools: Array.from(roleToSchoolSet.get(role) || [])
      }));
    },

    // 获取状态样式类
    getStatusClass(expireTime) {
      const nowTime = getSystemTimeSync();
      return expireTime > nowTime ? {
        text:'生效中',
        style:'status-active'
      } : {
        text:'已失效',
        style:'status-inactive'
      };
    },
    // 当前页改变
    handleCurrentChange(val) {
      this.pageNo = val;
      this.handleQuery();
    },

    // 创建成功回调
    handleCreateSuccess() {
      // 刷新用户列表
      this.fetchUserList(this.filterForm);
    }
  }
}
</script>

<style scoped lang="less">
.container {
  background: #EDE4DA;
  min-height: 100vh;
  padding-top: 72px;
  // padding-bottom: 72px;
  box-sizing: border-box;
  .teacher-page-hd-roles{
    display: flex;
    align-items: center;
    gap: 30px;
    span{
      width: 76px;
      display: flex;
      height: 28px;
      border-radius: 4px;
      align-items: center;
      justify-content: center;
      font-size: 13px;
      font-weight: 500;
      i{
        width: 16px;
        height: 16px;
        margin-right: 6px;
      }
      &.teacher {
        border: 0.5px solid #B8862B;
        color: #B8862B;
        background: #FFF3DC;
        i{
          background: url("./images/techer.png") center / cover no-repeat;
        }
      }
      &.admin {
        border: 0.5px solid #FF6720;
        color: #FF6720;
        background: #FFF0E9;
        i{
          background: url("./images/admin.png") center / cover no-repeat;
        }
      }
    }
  }
  .page-content {
    max-width: 1400px;
    margin: 24px auto;
    border-radius: 12px;

    .page-content-head {
      background: #FFFFFF;
      padding: 0 40px;
      display: flex;
      flex-direction: column;
      border-radius: 12px 12px 0 0;

      .page-title-warp {
        position: relative;
        text-align: center;
        width: 100%;
        font-weight: 600;
        margin-top: 36px;
        margin-bottom: 32px;

        .back {
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          font-size: 16px;
          color: #4E5969;
          cursor: pointer;

          i {
            color: #4E5969;
            margin-right: 8px;
          }
        }

        .title {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          font-weight: 600;
          color: #000000;

          i {
            width: 30px;
            height: 30px;
            background: url("./images/user.png") no-repeat center center;
            background-size: cover;
            margin-right: 4px;
          }
        }
      }

      .filter-section {
        width: 100%;
        margin-bottom: 32px;
        //display: flex;
        //justify-content: space-between;
        //align-items: flex-end;
        .filter-form {
          flex: 1;
          text-align: left;
          position: relative;
          margin-bottom: 24px;
          .el-form-item {
            margin-bottom:0;
            margin-right: 28px;
            .el-form-item__label {
              font-size: 16px;
              font-weight: bold;
              padding: 0 4px 0 0;
              color: #000;
            }

            .el-input, .el-select {
              width: 120px;
              &.form-select-width{
                width: 200px;
              }
            }
          }
        }
        .form-btns{
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          .el-button{
            height: 36px;
            line-height: 36px;
            text-align: center;
            border-radius: 90px;
            border: none;
            outline: none;
            font-size: 14px;
            font-weight: 500;
            padding: 0 24px;
            i {
              margin-right: 10px;
            }
            &.create-btn{
              background: #E60012;
              color: #FFFFFF;
            }
            &.createAll-btn{
              background: #F2F3F5;
              color: #000000;
            }
            &.search-btn{
              background: #000000;
              color: #fff;
            }
            &.reset-btn{
              background: #F2F3F5;
              color: #000;
            }
          }
        }
        .action-buttons {
          display: flex;
          gap: 12px;
          margin-left: 24px;
          flex-wrap: wrap;

          .el-button {
            padding: 12px 24px;
            font-size: 16px;
            font-weight: 500;
            white-space: nowrap;
          }
        }
      }
    }

    .page-content-body {
      background: #F7F6F5;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      padding: 40px;
      box-sizing: border-box;
      border-radius: 0 0 12px 12px;
      .table-section {
        width: 100%;
        //max-width: 1200px;
        margin-bottom: 32px;
        .el-table__header{
          thead{
            color: #000000;
            font-weight: 500;
            tr{
              background: #F7F1E6;
              th{
                background: #F7F1E6;
                border-bottom: none !important;
              }
            }
          }
          height: 60px;
        }
        .el-table {
          background: #FFFFFF;
          border-radius: 8px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

          .el-table__header {
            background: #f8f9fa;

            th {
              background: #f8f9fa;
              color: #1D2129;
              font-weight: 600;
              border-bottom: 1px solid #e4e7ed;
            }
          }

          .el-table__body {
            tr {
              &:hover {
                background: #f5f7fa;
              }

              td {
                border-bottom: 1px solid #f0f0f0;
              }
            }
          }
        }
      }

      .pagination-section {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        box-sizing: border-box;
        align-items: center;
        .pagination-info {
          font-size: 14px;
          color: #000;
          margin-right: 30px;
          font-weight: 500;
          span {
            margin: 0 4px;
          }
        }

        .pagination-controls {
          display: flex;
          align-items: center;

          .el-pagination {
            margin-right: 0;
            .el-pager li {
              background: none;
              &.active {
                background: #E60012;
                color: #fff;
                border-color: #E60012;
              }
            }
          }

          .page-jump {
            display: flex;
            align-items: center;
            font-size: 14px;
            color: #606266;

            span {
              margin: 0 4px;
            }
          }
        }
      }
    }
  }
}

// 状态样式
.status-active {
  color: #67C23A;
  font-weight: 500;
}

.status-inactive {
  color: #F56C6C;
  font-weight: 500;
}
</style>

<style>
/* 全局样式覆盖 */
.container {
  .filter-form{
    .el-form-item__label {
      font-size: 16px;
      font-weight: bold;
      padding: 0 4px 0 0;
      margin-right: 8px;
    }
    .el-input__inner, .el-select .el-input__inner {
      height: 40px;
      line-height: 40px;
      border-radius: 4px;
      width: 120px;
    }
    .form-select-width{
      width: 220px;
      .el-input__inner{
        width: 100%;
      }
    }
  }
  .el-button {
    height: 32px;
    padding: 0 16px;
    border-radius: 4px;
  }

  .el-table {
    .el-table__header-wrapper {
      .el-table__header {
        thead{
          color: #000000;
          font-weight: 500;
          tr{
            background: #F7F1E6;
            th{
              background: #F7F1E6;
              border-bottom: none !important;
            }
          }
        }
        height: 60px;
      }
    }

    .el-table__body-wrapper {
      .el-table__body{
        .el-table__cell{
          padding: 10px 0;
          .roles-container {
            display: flex;
            //align-items: center;
            gap: 8px;
            justify-content: center;
            flex-direction: column;
            .role-item {
              padding: 8px 0;
              display: flex;
              align-items: center;
              border-bottom: 1px solid #ece9e9;
              &:last-child {
                border-bottom: none;
              }
              .role-schools{
                flex: 1;
                margin-left: 10px;
                white-space: nowrap;
                max-width: 80%;
                overflow-x: scroll;
              }
            }
          }
          .roles-school-list {
            .role-schools-row {
              margin-bottom: 4px;
              margin-right: 6px;
              &:last-child {
                margin-bottom: 0;
              }
            }
          }
         .levelTag{
            font-weight: 500;
            background: linear-gradient(270deg, rgba(255, 233, 233, 0.6) 0%, rgba(255, 240, 230, 0.6) 100%);
            border-radius: 4px;
            height: 24px;
            line-height: 24px;
            color: #D03C48;
            border: none;
          }
        }
        tr{
          td{
            border-bottom: none !important;
          }
        }
      }
    }
  }

  .el-tag {
    border-radius: 12px;
    padding: 0 8px;
    height: 24px;
    line-height: 22px;
    font-size: 12px;
  }

  .el-pagination {
    .el-pager li {
      min-width: 32px;
      height: 32px;
      font-size: 14px;
      color: #000;
      line-height: 30px;
      border-radius: 4px;
      margin: 0 2px;
      background: none;
      &.active{
        color: #E60012;
      }
    }

    .btn-prev, .btn-next {
      width: 32px;
      height: 32px;
      line-height: 30px;
      border-radius: 4px;
      background: none;
    }
  }
}
</style>